var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTilePink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#EF69B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5972 17.5082L32.7804 12.6914L37.5972 7.87463",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3596 12.1863L37.5972 7.87478",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59717 17.5082L8.41394 12.6914L3.59717 7.87463",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83478 12.1863L3.59717 7.87478",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5972 32.5848L32.7804 27.7681L37.5972 22.9513",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3596 27.2629L37.5972 22.9514",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59717 32.5848L8.41394 27.7681L3.59717 22.9513",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83478 27.2629L3.59717 22.9514",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0425 36.407L28.8593 31.5902L33.676 36.407",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9556 32.6867L33.6762 36.407",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 36.407L11.7386 31.5902L16.5554 36.407",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 32.6867L16.5556 36.407",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0425 3.95435L28.8593 8.77112L33.676 3.95435",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9556 7.67459L33.6762 3.95435",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 3.95435L11.7386 8.77112L16.5554 3.95435",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 7.67459L16.5556 3.95435",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4698 25.0354L15.3245 20.1808L10.4698 15.3262",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6314 25.094L7.71812 20.1808L12.6313 15.2676",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8966 25.035L32.7512 20.1804L27.8966 15.3258",
    stroke: "#D44190",
    strokeWidth: 3.1365
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0581 25.0938L25.1449 20.1806L30.0581 15.2675",
    stroke: "#DF56A0",
    strokeWidth: 3.1365
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3245 12.8276L20.1221 8.01091L24.9388 12.8276L20.1221 17.6444L15.3245 12.8276Z",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3245 27.5327L20.1221 22.716L24.9388 27.5327L20.1221 32.3495L15.3245 27.5327Z",
    stroke: "#D44190",
    strokeWidth: 1.56825
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6736 7.47826L15.3245 12.8274L20.6736 18.1765",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6482 22.2091L15.3245 27.5329L20.6482 32.8567",
    stroke: "#DF56A0",
    strokeWidth: 1.56825
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilePink);
export default __webpack_public_path__ + "static/media/tile-pink.36eb2b6b.svg";
export { ForwardRef as ReactComponent };